var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10.9341H22C20.6739 10.9341 19.4021 11.4609 18.4645 12.3985C17.5268 13.3362 17 14.608 17 15.9341V18.9341H14V22.9341H17V30.9341H21V22.9341H24L25 18.9341H21V15.9341C21 15.6689 21.1054 15.4145 21.2929 15.227C21.4804 15.0394 21.7348 14.9341 22 14.9341H25V10.9341Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.d995ecfd9353bdf2a0e619c046aa2882.svg";
export { ForwardRef as ReactComponent };